import React from 'react';
import { Select, MenuItem } from '@mui/material';

export default function SearchUnit(props) {

    return (
        <>
        <Select id="direction" value={props.direction} onChange={(event) => props.setDirection(event.target.value)}>
            <MenuItem value="A">All</MenuItem>
            <MenuItem value="I">Inbound</MenuItem>
            <MenuItem value="O">Outbound</MenuItem>
        </Select>
            </>
    )
}
